import React, { useEffect, useState, Fragment, useRef } from 'react';
import { PageHeader } from '../../../../Common';
import { DailyCropRecoReportContent } from '../../../Common/Table/tableContent';
import services from '../services';
import InputLabel from '@material-ui/core/InputLabel';
import $ from 'jquery';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import Joi from '@hapi/joi';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import { CSVLink, CSVDownload } from "react-csv";
import TextField from '@material-ui/core/TextField';
import { DailyCollectionCategoryObject } from '../DailyCollectionCategorySchema';
import { validateProperty, validate } from "../../../Common";
import CreatePdf from './createPdf';
import _ from 'lodash';
import '../Pages/tableFooter.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'DAILYCROPRECONCILLIATIONREPORT';

export function DailyCropReconcilliationListing(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [count, setCount] = useState(0);
    const [errors, setErrors] = useState({})
    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1070, 700]
    };

    const schema = Joi.object(DailyCollectionCategoryObject).options({ allowUnknown: true })
    const pdfRef = useRef(null);

    const [dailyCropReconcilliation, setDailyCropReconcilliation] = useState([])
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);

    const [searchForm, setSearchForm] = useState(
        {
            groupID: "0",
            routeID: "0",
            factoryID: "0",
            searchdate: "",
            reportType: "0"
        }
    );

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "",
        route: "",
        factory: "",
        date: "",
        reportType: ""
    })

    const [dynamicCsvHeaders, setDynamicCsvHeaders] = useState([]);
    const csvHeaders = [
        { label: "Route Name", value: "collectionPointName" },
        { label: "Reg. Number", value: "registrationNumber" },
        { label: "Customer Name", value: "customerFullName" },
        { label: "Route Tag", value: "tagNumber" },
        { label: "Factory Tag", value: "ftagNumber" },
        { label: "Field Actual Amount (Kg)", value: "actualAmount" },
        { label: "Field Gross Amount (Kg)", value: "grossAmount" },
        { label: "Field Net Amount (Kg)", value: "netAmount" },
        { label: "Factory Actual Amount (Kg)", value: "factualAmount" },
        { label: "Factory Gross Amount (Kg)", value: "fGrossAmount" },
        { label: "Factory Net Amount (Kg)", value: "fNetAmount" },
        { label: "Gross Variance (Kg)", value: "grossVariance" },
        { label: "Gain/Loss", value: "gainOrLoss" },
    ];

    const [contentRowNames, setContentRowNames] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [excelData, setExcelData] = useState([]);
    const [feildAvailabeDedauctionTypes, setFeildAvailabeDedauctionTypes] = useState([]);
    const [weighAvailabeDedauctionTypes, setWeighAvailabeDedauctionTypes] = useState([]);
    const [weighDedauctionTypesTable, setWeighDedauctionTypesTable] = useState([]);
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
        isVarianceColumnEnabled: false,
        isActulaAmountColumnEnabled: false
    });
    const [mobileSessionKeys, setMobileSessionKeys] = useState([]);
    const initialContentRowNames = ["collectionPointName", "registrationNumber", "customerFullName", "tagNumber", "ftagNumber", "actualAmount", "grossAmount",
        "netAmount", "factualAmount", "fGrossAmount", "fNetAmount", "grossVariance", "gainOrLoss"];
    const [totalValues, setTotalValues] = useState({
        feildActualTot: 0,
        feildGrossTot: 0,
        feildNetTot: 0,
        factoryActualTot: 0,
        factoryGrossTot: 0,
        factoryNetTot: 0,
        grossVariancetot: 0
    })
    const [dynamicDeductionTotal, setDynamicDeductionTotal] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getEsatesForDropDown()
        )
    }, [searchForm.groupID])

    useEffect(() => {
        trackPromise(
            GetAllRoutesForDropDown()
        )
    }, [searchForm.factoryID])

    useEffect(() => {
        destroyDataTable(["#example", "#examplePdf"]);
        createDataTable(contentRowNames, ["#example", "#examplePdf"]);
    }, [dailyCropReconcilliation])

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWDAILYCROPRECONCILLIATIONREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined,
        });

        var token = tokenService.getUserDetailsFromToken();
        setSearchForm({
            ...searchForm,
            groupID: token.groupID,
            factoryID: token.operationEntityID
        });

        setGroupDropDownData();
    }

    async function setGroupDropDownData() {
        const result = await services.getGroups()
        setGroups(result)
    }

    async function getEsatesForDropDown() {
        const factoryList = await services.getFactoryByGroupID(searchForm.groupID);
        setFactories(factoryList);
    }

    async function GetAllRoutesForDropDown() {
        const routeList = await services.GetAllRoutesByFactoryID(searchForm.factoryID);
        setRoutes(routeList);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    function handleChange(e) {
        const target = e.target
        const value = target.name === 'active' ? target.checked : target.value

        const error = { ...errors }
        const errorMessage = validateProperty(target, DailyCollectionCategoryObject)
        errorMessage ? error[target.name] = errorMessage : delete error[target.name]

        setSearchForm({
            ...searchForm,
            [e.target.name]: value
        });
        setErrors(error);
        clearTableRelatedData();
    }

    async function handleSearch(e) {
        e.preventDefault();
        setIsTableHide(true);

        setSearchDataForPdf();

        const errorMessages = validate(schema, searchForm)
        errorMessages !== null ? setErrors(errorMessages) : setErrors({})
        if (errorMessages) return;

        var reportData = await services.getReportData(searchForm);

        var factoryWeighReportDetails = reportData.factoryWeighResult;
        var filedReportData = reportData.dialyCropRecoResult;
        const feildDeductionTypes = reportData.deductionTypesOfFeildResult;
        const weighDeductionTypes = reportData.deductionTypesOfFactoryWeighResult;

        let weighDeductionTypesCopy = [...weighDeductionTypes];

        weighDeductionTypes.forEach((val, index) => weighDeductionTypes[index] = "f" + val.deductionTypeName);
        feildDeductionTypes.forEach((val, index) => feildDeductionTypes[index] = val.deductionTypeName);

        setFeildAvailabeDedauctionTypes(feildDeductionTypes);
        setWeighAvailabeDedauctionTypes(weighDeductionTypes);

        weighDeductionTypesCopy.forEach((val, index) => weighDeductionTypesCopy[index] = val.deductionTypeName);
        setWeighDedauctionTypesTable(weighDeductionTypesCopy);

        let groupedFactoryWeighResult = groupByTag(factoryWeighReportDetails);
        let factoryWeighKeys = Object.keys(groupedFactoryWeighResult);
        let factoryWeighArrayCollection = [];

        factoryWeighKeys.forEach(x => {
            var res = pivotFactoryWeighResult(groupedFactoryWeighResult[x]);
            factoryWeighArrayCollection.push(...res);
        });

        let groupedFiledResult = groupByTag(filedReportData);
        let keys = Object.keys(groupedFiledResult);
        let filedarrayCollection = [];

        keys.forEach(x => {
            var res = pivotResultData(groupedFiledResult[x]);
            filedarrayCollection.push(...res);
        });

        var joinedArray = _.merge(_.keyBy(filedarrayCollection, 'tagNumber'), _.keyBy(factoryWeighArrayCollection, 'ftagNumber'));

        var joinedResult = [];
        var finalResult = [];
        var finalMissmatchResult = [];

        Object.keys(joinedArray).forEach(x => joinedResult.push(joinedArray[x]));
        joinedResult.forEach(x => {
            finalResult.push(x);
        });

        finalResult.forEach(x => {
            if (x.collectionPointName === undefined || x.customerFullName === undefined
                || x.registrationNumber === undefined) {
                x.collectionPointName = x.fcollectionPointName;
                x.customerFullName = x.fcustomerFullName;
                x.registrationNumber = x.fregistrationNumber;
            }

            var gainOrLossCal = ((parseFloat(x.fGrossAmount))
                - (parseFloat(x.grossAmount)));
            var gainOrLossVal;

            x.grossVariance = isNaN(gainOrLossCal) ? "-" : gainOrLossCal;

            if (gainOrLossCal === 0 || isNaN(gainOrLossCal)) {
                gainOrLossVal = "-";
            } else if (gainOrLossCal > 0) {
                gainOrLossVal = "Gain";
            } else {
                gainOrLossVal = "Loss";
            }

            x.gainOrLoss = gainOrLossVal;
        });


        let rowNames = initialContentRowNames;
        let contentRowNames = csvHeaders;

        rowNames.splice(7, 0, ...feildDeductionTypes);
        rowNames.splice((10 + feildDeductionTypes.length), 0, ...weighDeductionTypes);
        setContentRowNames(rowNames);

        let deductions = [];


        feildDeductionTypes.forEach((deductionType, index) => {
            contentRowNames.splice((7 + index), 0, { label: deductionType, value: deductionType });
            var obj = {
                name: deductionType,
                value: 0
            };
            deductions.push(obj)
        })

        weighDeductionTypes.forEach((deductionType, index) => {
            contentRowNames.splice((10 + feildDeductionTypes.length + index), 0, { label: `Factory ${deductionType.substring(1)}`, value: deductionType });
            var obj = {
                name: deductionType,
                value: 0
            };
            deductions.push(obj)
        })


        setDynamicCsvHeaders(contentRowNames);

        if (finalResult.length > 0) {
            setIsReportButtonsEnabled(true);
        } else {
            setIsReportButtonsEnabled(false);
        }

        setIsTableHide(false);
        var actualTot = 0;
        var netAmount = 0;
        var grossAmount = 0;
        var factualTot = 0;
        var fnetAmount = 0;
        var fgrossAmount = 0;
        var grossTotal = 0;


        if (searchForm.reportType === "1") {

            finalResult.forEach(x => {

                if (x.actualAmount !== x.factualAmount && (x.ftagNumber === undefined ? false : x.ftagNumber === x.tagNumber)) {
                    finalMissmatchResult.push(x);

                    actualTot += (x.actualAmount === undefined ? 0 : parseFloat(x.actualAmount));
                    netAmount += (x.netAmount === undefined ? 0 : parseFloat(x.netAmount));
                    grossAmount += (x.grossAmount === undefined ? 0 : parseFloat(x.grossAmount));
                    factualTot += (x.factualAmount === undefined ? 0 : parseFloat(x.factualAmount));
                    fnetAmount += (x.fNetAmount === undefined ? 0 : parseFloat(x.fNetAmount));
                    fgrossAmount += (x.fGrossAmount === undefined ? 0 : parseFloat(x.fGrossAmount));
                    grossTotal += ((x.grossVariance === undefined || isNaN(x.grossVariance)) ? 0 
                        : parseFloat(x.grossVariance));
                    deductions = getDynamicTotal(deductions, x);
                }

            })

            setDynamicDeductionTotal(deductions);
            setDailyCropReconcilliation(finalMissmatchResult);
            createDataForExcel(finalMissmatchResult);
        } else if (searchForm.reportType === "2") {
            finalResult.forEach(x => {
                if (x.tagNumber !== x.ftagNumber) {
                    finalMissmatchResult.push(x);

                    actualTot += (x.actualAmount === undefined ? 0 : parseFloat(x.actualAmount));
                    netAmount += (x.netAmount === undefined ? 0 : parseFloat(x.netAmount));
                    grossAmount += (x.grossAmount === undefined ? 0 : parseFloat(x.grossAmount));
                    factualTot += (x.factualAmount === undefined ? 0 : parseFloat(x.factualAmount));
                    fnetAmount += (x.fNetAmount === undefined ? 0 : parseFloat(x.fNetAmount));
                    fgrossAmount += (x.fGrossAmount === undefined ? 0 : parseFloat(x.fGrossAmount));
                    grossTotal += ((x.grossVariance === undefined || isNaN(x.grossVariance)) ? 0
                        : parseFloat(x.grossVariance));

                    deductions = getDynamicTotal(deductions, x);
                }

            })
            setDynamicDeductionTotal(deductions);
            setDailyCropReconcilliation(finalMissmatchResult);
            createDataForExcel(finalMissmatchResult);
        } else {
            finalResult.forEach(x => {

                actualTot += (x.actualAmount === undefined ? 0 : parseFloat(x.actualAmount));
                netAmount += (x.netAmount === undefined ? 0 : parseFloat(x.netAmount));
                grossAmount += (x.grossAmount === undefined ? 0 : parseFloat(x.grossAmount));
                factualTot += (x.factualAmount === undefined ? 0 : parseFloat(x.factualAmount));
                fnetAmount += (x.fNetAmount === undefined ? 0 : parseFloat(x.fNetAmount));
                fgrossAmount += (x.fGrossAmount === undefined ? 0 : parseFloat(x.fGrossAmount));
                grossTotal += ((x.grossVariance === undefined || isNaN(x.grossVariance)) ? 0
                    : parseFloat(x.grossVariance));

                deductions = getDynamicTotal(deductions, x);
            })
            setDynamicDeductionTotal(deductions);
            setDailyCropReconcilliation(finalResult);
            createDataForExcel(finalResult);
        }


        setTotalValues({
            ...totalValues,
            feildActualTot: actualTot.toFixed(2),
            feildNetTot: netAmount.toFixed(2),
            feildGrossTot: grossAmount.toFixed(2),
            factoryGrossTot: fgrossAmount.toFixed(2),
            factoryNetTot: fnetAmount.toFixed(2),
            factoryActualTot: factualTot.toFixed(2),
            grossVariancetot: grossTotal
        });


    }

    function getDynamicTotal(deductionIntit, dataObject) {
        var dynamicValues = [];
        var inits = deductionIntit;

        for (const property in dataObject) {
            if (
                property !== "registrationNumber" && property !== "customerFullName"
                && property !== "tagNumber" && property !== "ftagNumber"
                && property !== "actualAmount" && property !== "grossAmount"
                && property !== "netAmount" && property !== "factualAmount"
                && property !== "fGrossAmount" && property !== "fNetAmount"
                && property !== "grossVariance" && property !== "collectionPointName"
                && property !== "gainOrLoss" && property !== "ffullTime"
                && property !== "fcustomerFullName" && property !== "fregistrationNumber"
                && property !== "fcollectionPointName" && property !== "fullTime"
            ) {
                let dynamictype = {
                    type: property,
                    value: parseFloat(dataObject[property])
                }

                dynamicValues.push(dynamictype);
            }
        }

        inits.forEach(z => {
            let obj = dynamicValues.find(o => o.type === z.name);
            if (obj != null) {
                z.value += parseFloat(obj.value);
            }
        });

        return inits;
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Crop Reconcilliation',
            fileName: 'DailyCropReconcilliationReport',
            writeOptions: {}
        }

        var copyOfExcelData = _.cloneDeep(excelData);

        var totalRecord = {
            collectionPointName: "Total",
            actualAmount: totalValues.feildActualTot,
            grossAmount: totalValues.feildGrossTot,
            netAmount: totalValues.feildNetTot,
            factualAmount: totalValues.factoryActualTot,
            fGrossAmount: totalValues.factoryGrossTot,
            fNetAmount: totalValues.factoryNetTot,
            grossVariance: totalValues.grossVariancetot,
        }

        feildAvailabeDedauctionTypes.forEach((data, index) => {
            let feild = dynamicDeductionTotal.find(o => o.name === data);
            if (feild === undefined || feild === null) {
                totalRecord[data] = "0.00";
            } else {
                totalRecord[data] = feild.value.toFixed(2);
            }
        });

        weighDedauctionTypesTable.map((data, index) => {
            let factory = dynamicDeductionTotal.find(o => o.name === "f" + data);
            if (factory === undefined || factory === null) {
                totalRecord["f" + data] = "0.00";
            } else {
                totalRecord["f" + data] = factory.value.toFixed(2);
            }
        });

        copyOfExcelData.push(totalRecord, {}, {
            collectionPointName: "Date: " + new Date().toLocaleString(),
            registrationNumber: "User: " + tokenService.getUserNameFromToken()
        }, {});

        xlsx(dynamicCsvHeaders, copyOfExcelData, settings, true)
    }

    function setSearchDataForPdf() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            route: routes[searchForm.routeID],
            factory: factories[searchForm.factoryID],
            date: searchForm.searchdate,
            type: searchForm.reportType === "1" ? "Amount Mismatch" :
                (searchForm.reportType === "2" ? "Tag Mismatch" : "Default")
        })
    }

    function createDataForExcel(array) {
        setExcelData(array);
    }

    function groupByTag(objectArray) {
        return objectArray.reduce(function (acc, obj) {
            let key = obj['tagNumber']
            let keyCp = obj['collectionPointID']
            if (!acc[key] && !acc[keyCp]) {
                acc[key] = []
            }
            acc[key].push(obj)
            return acc
        }, {});
    }

    const convertFrom24To12Format = (time24) => {
        const [sHours, minutes] = time24.match(/([0-9]{1,2}):([0-9]{2})/).slice(1);
        const period = +sHours < 12 ? 'AM' : 'PM';
        const hours = +sHours % 12 || 12;

        return `${hours}:${minutes} ${period}`;
    }

    function pivotResultData(data) {
        var result = [];

        data.forEach(function (e) {
            var a = e.tagNumber;

            if (!this[a]) {
                this[a] = {
                    collectionPointName: e.collectionPointName,
                    registrationNumber: e.registrationNumber,
                    actualAmount: e.actualAmount.toFixed(2),
                    customerFullName: e.customerFullName,
                    tagNumber: e.tagNumber,
                    fullTime: e.startTime.split('T')[0],
                    netAmount: e.netAmount.toFixed(2),
                    grossAmount: e.grossAmount.toFixed(2),
                }
                result.push(this[a]);
            }
            this[a][e.deductionTypeName] = e.totalDeduction.toFixed(2);
        }, {});


        return result;
    }

    function pivotFactoryWeighResult(data) {
        var result = [];

        data.forEach(function (e) {
            var a = e.tagNumber;
            if (!this[a]) {
                this[a] = {
                    fcollectionPointName: e.collectionPointName,
                    fcustomerFullName: e.customerFullName,
                    fregistrationNumber: e.registrationNumber,
                    factualAmount: e.fActualAmount.toFixed(2),
                    ftagNumber: e.tagNumber,
                    ffullTime: e.startTime.split('T')[0],
                    fNetAmount: e.fNetAmount.toFixed(2),
                    fGrossAmount: e.fGrossAmount.toFixed(2),
                }
                result.push(this[a]);
            }
            this[a]["f" + e.fDeductionTypeName] = e.fTotalDeduction.toFixed(2);

        }, {});
        return result;
    }

    function destroyDataTable(dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable().destroy();
        });
    }

    function createDataTable(contentRowNames, dataTables) {
        dataTables.forEach(x => {
            $(x).DataTable({
                order: [[0, "asc"]],
                destroy: x === '#examplePdf' ? true : false,
                searching: x === '#examplePdf' ? false : true,
                paging: x === '#examplePdf' ? false : true,
                scrollX: false,
                rowGroup: {
                    startRender: null,
                    endRender: function (rows, group) {
                        var result = setSubTotalRow(rows, group, contentRowNames);
                        return result;
                    },
                    dataSrc: 0
                },
                initComplete: function (settings, json) {
                    if (x !== '#examplePdf') {
                        $('#example').wrap("<div style='overflow:auto; width:100%;position:relative;'></div>");
                    }
                }
            });
        });
    }

    function setSubTotalRow(rows, group, contentRowNames) {
        var dynamicCountVariable = [];

        for (var i = 0; i < contentRowNames.length; ++i) {
            if (i > 4 && (i + 1) !== contentRowNames.length) {
                dynamicCountVariable[i] = rows
                    .data()
                    .pluck(i)
                    .reduce(function (a, b) {
                        return checkUndefined(a) + checkUndefined(b) * 1;
                    }, 0);
            }
        }

        var rowData = '';

        for (var i = 0; i < contentRowNames.length; ++i) {
            if (i > 4 && (i + 1) !== contentRowNames.length) {
                if ((i + 1) === (contentRowNames.length - 1)) {
                    rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i] + '</b></td>';
                } else {
                    rowData += '<td style="text-align:right"><b>' + dynamicCountVariable[i].toFixed(2) + '</b></td>';
                }
            }
        }

        return $('<tr/>')
            .append('<td colspan="5"><b>Total for ' + group + '</b></td>')
            .append(rowData)
            .append('<td></td>');
    }

    function checkUndefined(value) {
        if (value === "-" || isNaN(value)) {
            return 0;
        } else {
            return parseFloat(value);
        }
    }

    function onCancelClick() {
        setSearchForm({
            ...searchForm,
            routeID: "0",
            searchdate: "",
            reportType: "0"
        });
        setErrors("");
        clearTableRelatedData();
    }

    function clearTableRelatedData() {
        setIsTableHide(true);
        destroyDataTable(["#example", "#examplePdf"]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12 card">
                    <div ref={pdfRef}>
                        <PageHeader
                            title="Daily Crop Reconcilliation Report"
                        />
                        <div className="card-body">
                            <form onSubmit={(e) => trackPromise(handleSearch(e))}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            id="groupID"
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            name="groupID"
                                            value={searchForm.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="factoryID">Factory *</InputLabel>
                                        <Select fullWidth
                                            id="factoryID"
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            name="factoryID"
                                            value={searchForm.factoryID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select factory--</MenuItem>
                                            {generateDropDownMenu(factories)}
                                        </Select>
                                        {errors["factoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["factoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="routeID">Route *</InputLabel>
                                        <Select fullWidth
                                            id="routeID"
                                            name="routeID"
                                            value={searchForm.routeID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select route--</MenuItem>
                                            {generateDropDownMenu(routes)}
                                        </Select>
                                        {errors["routeID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["routeID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="searchdate">Date *</InputLabel>
                                        <TextField
                                            fullWidth
                                            id="searchdate"
                                            name="searchdate"
                                            type="date"
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="reportType">Type *</InputLabel>
                                        <Select fullWidth
                                            id="reportType"
                                            name="reportType"
                                            value={searchForm.reportType}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select report type--</MenuItem>
                                            <MenuItem value="1">Amount Mismatch</MenuItem>
                                            <MenuItem value="2">Tag Mismatch</MenuItem>
                                            <MenuItem value="3">Default</MenuItem>
                                        </Select>
                                        {errors["reportType"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["reportType"]}</FormHelperText>}
                                    </div>
                                </div>

                                <input
                                    type="submit"
                                    disabled={validate(schema, searchForm)}
                                    className="btn btn-primary"
                                    value="Generate"
                                />
                                <input type="reset"
                                    className="btn btn-warning pull-right"
                                    value="Clear"
                                    onClick={onCancelClick}
                                />

                                {isTableHide ? null :
                                    <div>
                                        <div className="table-responsive row-top-gap" style={{ width: "1400px" }}>
                                            <div className="card shadow-none bg-light">
                                                <div className="card-body">
                                                    <table
                                                        id="example"
                                                        className="display dataTable">
                                                        <thead>
                                                            <tr>
                                                                <th rowSpan="2">Route Name</th>
                                                                <th rowSpan="2">Reg. Number</th>
                                                                <th rowSpan="2">Customer Name</th>
                                                                <th rowSpan="2">Route Tag</th>
                                                                <th rowSpan="2">Factory Tag</th>
                                                                <th colSpan={feildAvailabeDedauctionTypes.length + 3} scope="colgroup">Field</th>
                                                                <th colSpan={weighAvailabeDedauctionTypes.length + 3} scope="colgroup">Factory Weigh</th>
                                                                <th rowSpan="2">Gross Variance</th>
                                                                <th rowSpan="2">Gain/Loss</th>
                                                            </tr>
                                                            <tr>
                                                                <th scope="col">Actual Amount (Kg)</th>
                                                                <th scope="col">Gross Amount (Kg)</th>
                                                                {feildAvailabeDedauctionTypes.map((data, index) => {
                                                                    return (
                                                                        <th scope="col" key={index}>{data}</th>
                                                                    );
                                                                })}
                                                                <th scope="col">Net Amount (Kg)</th>
                                                                <th scope="col">Actual Amount (Kg)</th>
                                                                <th scope="col">Gross Amount (Kg)</th>
                                                                {weighDedauctionTypesTable.map((data, index) => {
                                                                    return (
                                                                        <th scope="col" key={index}>{data}</th>
                                                                    );
                                                                })}
                                                                <th scope="col">Net Amount (Kg)</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <DailyCropRecoReportContent
                                                                data={dailyCropReconcilliation}
                                                                contentRowNames={contentRowNames}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                        <tfoot>
                                                            <tr>
                                                                <th colSpan="5" style={{ textAlign: "center" }}>Total</th>
                                                                <th style={{ textAlign: "right" }}>{totalValues.feildActualTot}</th>
                                                                <th style={{ textAlign: "right" }}>{totalValues.feildGrossTot}</th>

                                                                {feildAvailabeDedauctionTypes.map((data, index) => {
                                                                    let feild = dynamicDeductionTotal.find(o => o.name === data)
                                                                    if (feild === undefined || feild === null) {
                                                                        return (
                                                                            <th key={index} style={{ textAlign: "right" }}>0.00</th>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <th key={index} style={{ textAlign: "right" }}>{feild.value.toFixed(2)}</th>
                                                                        );
                                                                    }
                                                                })}

                                                                <th style={{ textAlign: "right" }}>{totalValues.feildNetTot}</th>
                                                                <th style={{ textAlign: "right" }}>{totalValues.factoryActualTot}</th>
                                                                <th style={{ textAlign: "right" }}>{totalValues.factoryGrossTot}</th>

                                                                {weighDedauctionTypesTable.map((data, index) => {
                                                                    let factory = dynamicDeductionTotal.find(o => o.name === "f" + data);

                                                                    if (factory === undefined || factory === null) {
                                                                        return (
                                                                            <th key={index} style={{ textAlign: "right" }}>0.00</th>
                                                                        );
                                                                    } else {
                                                                        return (
                                                                            <th key={index} style={{ textAlign: "right" }}>{factory.value.toFixed(2)}</th>
                                                                        );
                                                                    }
                                                                })}

                                                                <th style={{ textAlign: "right" }}>{totalValues.factoryNetTot}</th>
                                                                <th style={{ textAlign: "right" }}>{totalValues.grossVariancetot}</th>
                                                                <th></th>
                                                            </tr>
                                                        </tfoot>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        {!isReportButtonsEnabled ? null :
                                            <div className="pt-2">
                                                <ReactToPrint
                                                    documentTitle={"Daily Crop Reconcilliation Report"}
                                                    trigger={() => <input
                                                        type="button"
                                                        className="btn btn-primary pull-right ml-2"
                                                        value="Create PDF"
                                                    />}
                                                    content={() => componentRef.current}
                                                />
                                                <div hidden={true}>
                                                    <CreatePdf ref={componentRef} data={dailyCropReconcilliation}
                                                        rowNames={contentRowNames} searchData={selectedSearchValues}
                                                        feildAvailabeDedauctionTypes={feildAvailabeDedauctionTypes}
                                                        weighDedauctionTypesTable={weighDedauctionTypesTable} weighAvailabeDedauctionTypes={weighAvailabeDedauctionTypes}
                                                        dynamicDeductionTotal={dynamicDeductionTotal} totalValues={totalValues} />

                                                </div>
                                                <input
                                                    type="button"
                                                    className="btn btn-primary pull-right ml-2"
                                                    value="Excel"
                                                    onClick={createFile}
                                                />
                                            </div>}
                                    </div>
                                }
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}


